import React from 'react';
import PropTypes from 'prop-types';
import { SelectField } from 'shared/containers/portal_layout/HForm';
import shouldShowSelectForCollection from './shouldShowSelectForCollection';

const shouldShowLocationSelect = shouldShowSelectForCollection;
const shouldShowProviderSelect = shouldShowSelectForCollection;

const InternalReferringLocationAndProvider = props => {
  const {
    referringProviders,
    referringLocations,
    selectReferringLocation,
    selectReferringProvider,
  } = props;
  return (
    <div style={{ position: 'relative', zIndex: 1 }}>
      {shouldShowProviderSelect(referringProviders) ? (
        <SelectField
          simpleValue={false}
          name="internalReferringProviderEmployment"
          label="Referring Provider"
          options={referringProviders.items}
          isLoading={referringProviders.isFetching}
          valueKey="id"
          labelKey="nameWithAppellation"
          className="input-xxlarge"
          rawOnChange={selectReferringProvider}
        />
      ) : null}

      {shouldShowLocationSelect(referringLocations) ? (
        <SelectField
          name="internalReferringLocationId"
          options={referringLocations.items}
          label="Referring Location"
          isLoading={referringLocations.isFetching}
          valueKey="id"
          labelKey="name"
          className="input-xxlarge location-select"
          rawOnChange={selectReferringLocation}
        />
      ) : null}
    </div>
  );
};

InternalReferringLocationAndProvider.propTypes = {
  referringProviders: PropTypes.object.isRequired,
  referringLocations: PropTypes.object.isRequired,
  selectReferringProvider: PropTypes.func.isRequired,
  selectReferringLocation: PropTypes.func.isRequired,
};

export default InternalReferringLocationAndProvider;
